import { createApp } from 'vue'

import 'amfe-flexible'
import pinia from '@/stores/index'
import App from '@/App.vue'
import router from '@/router'
import i18n from '@/language'
import { directive } from '@/directive'
import { Lazyload } from 'vant'
import { H5Login } from '@/utils/H5Login'
import { Log } from '@/api/log'
import '@/theme/index.scss'
import { showConfirmDialog } from 'vant'
import { changeImgHost } from '@/utils/index'

import eruda from 'eruda'

if (import.meta.env.MODE !== 'production') {
    eruda.init()
}

if ('serviceWorker' in window.navigator) {
    navigator.serviceWorker
        .register('/_sw.js', { scope: '/' })
        .then(function (registration) {
            registration.update()
        })
        .catch((e) => {
            console.log(e)
        })
}

const checkUpdate = async () => {
    if ('connection' in navigator && !navigator.onLine) return
    const url = location.protocol + '//' + location.host + location.pathname + 'version.json?date=' + Date.now()
    try {
        const resp = await fetch(url.replace('index.html', ''), {
            cache: 'no-store',
            headers: {
                cache: 'no-store',
                'cache-control': 'no-cache',
            },
        })

        if (resp?.status === 200) {
            const data = await resp.json()
            if (__APP_VERSION__ !== data.version) {
                showConfirmDialog({
                    className: 'common-dialog',
                    title: i18n.global.t('sys_update_info'),
                    message: i18n.global.t('new_version_update_info'),
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                })
                    .then(() => {
                        location.reload()
                    })
                    .catch(() => {})
            }
        }
    } catch (e) {
        console.log(e)
    }
}

window.addEventListener('visibilitychange', async () => {
    if (document.visibilityState === 'visible') {
        checkUpdate()
    }
})

const app = createApp(App)

app.use(pinia)
    .use(router)
    .use(i18n)
    .use(Lazyload, {
        lazyComponent: true,
        filter: {
            // 在加载前处理图片 URL
            process(lazy) {
                // 替换旧域名为新域名

                lazy.src = changeImgHost(lazy.src)
                return lazy
            },
        },
        preLoad: 1.1,
    })
directive(app)
app.config.errorHandler = (err, instance, info) => {
    Log({
        event: 'app_error',
        content: {
            err,
            message: err?.message,
            stack: err?.stack,
            info,
            url: location.href,
        },
    })
    console.error(err)
}

// 获取服务端配置
checkUpdate()
app.mount('#app')
if (window.requestIdleCallback) {
    window.requestIdleCallback(() => {
        H5Login.init()
    })
}
